<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-home-app-container-detail">
      <div class="ccui-app-container">
        <div class="applicate-communicate">
          <div class="title">
            <el-row>
              <el-col :span="20">
                <div class="title-wuzi">
                  物资设备编码
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <div class="title-Company">
                  张翰 <span style="color: #ccc">中国交通建设股份有限公司</span>
                </div>
              </el-col>
              <el-col :span="4"
                ><div class="grid-content bg-purple" style="text-align: right;">
                  2024-02-12 12:23
                </div></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="title-remark">
                  物资编码是将物资按其分类内容进行有序编排，并用简明文字、符号或数字来代替物资的“名称”、“类别”。通过对物资的编码可以应用计算机进行高效率管理并可实现整个仓储作业的标准化管理
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <div class="operate-btn">
                  <span class="title-operate">
                    <el-button type="primary">回 复</el-button>
                  </span>
                  <span class="title-operate"
                    ><i class="el-icon-view"></i> <span>7</span></span
                  >
                  <span class="title-operate"
                    ><i class="el-icon-chat-dot-square"></i>
                    <span>2 </span>两条评论</span
                  >
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="ccui-app-container-tow">
        <div class="editor-content">
          <editor
            :editorContent="editorContent"
            @change="changeEditor"
          ></editor>
        </div>
        <div class="on-submit">
          <el-button type="primary" @click="onSubmit" style="width: 85px;"
            >发 表</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import editor from "@/app/shop/components/editor.vue";
export default {
  name: "topicReply",
  components: {
    baseBreadCrumb,
    editor
  },
  props: {
    source: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currBreadCrumb: [{ title: "主题详情" }],
      pageTotal: 10,
      pageSize: 0,
      pageNo: 0
    };
  },
  activated() {},
  deactivated() {
    this.initData();
  },
  methods: {
    onSubmit() {},
    titleHandle() {
      this.$router.push({
        path: "/postingAdd",
        query: {
          // source: item.source,
          // activeIndex: item.activeIndex
        }
      });
    },
    postingBtn() {
      this.$router.push({
        path: "/postingAdd",
        query: {
          // source: item.source,
          // activeIndex: item.activeIndex
        }
      });
    },
    handlePrev() {
      //   --this.pageNo;
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleNext() {
      //   ++this.pageNo;
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleSizeChange(val) {
      //   this.pageNo = 1;
      //   if (val !== "none") {
      //     this.pageSize = val;
      //     // setSessionItem("pageSize", this.tableName, val);
      //   }
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleCurrentChange(val) {
      // let searchFormData = getSessionItem("pageNo", this.tableName) || {};
      // setSessionItem("pageNo", this.tableName, {
      //   pageNo: val,
      //   searchForm: searchFormData.searchForm || {}
      // });
      // this.pageNo = val;
      // let obj = {
      //   pageNo: this.pageNo,
      //   pageSize: this.pageSize
      // };
      // this.getList(obj);
    }
  }
};
</script>

<style scoped lang="scss">
.ccui-app-container {
  min-height: 130px;
  //   padding: 24px !important;
}
.ccui-app-container-tow {
  min-height: 600px;
  background-color: #fff;
  padding: 24px !important;
  margin-bottom: 20px;
  font-size: 13px;
  .editor-content {
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 29px;
  }
}
.title {
  .title-wuzi {
    font-weight: 600;
    font-size: 18px;
    color: #4a4a4a;
  }
  .title-Company {
    margin: 5px 0 20px 0;
  }
  .title-remark {
    font-weight: 400;
    font-size: 13px;
    color: #4a4a4a;
    margin-bottom: 10px;
  }
  .operate-btn {
    .title-operate {
      margin-right: 17px;
      color: #999999;
      cursor: pointer;
    }
    .title-operate:hover {
      color: #0089ef;
    }
  }
}

.wrapper {
  position: relative;
}
.on-submit {
  width: 100%;
  text-align: right;
  margin-top: 15px;
}
</style>
